import React, { Suspense, useEffect, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import LandingPage from "./containers/LandingPage";
import RouteMap from "./components/content/Route";
import Runners from "./components/content/Runners";
import Donate from "./components/content/Donate";
import Cause from "./components/content/Cause";
import Gallery from "./containers/GalleryPage"

const App = () => {
  let routes = (
    <Switch>
      <Route path="/" exact component={LandingPage} />
      <Route path="/route" exact component={RouteMap} />
      <Route path="/team" exact component={Runners} />
      <Route path="/donate" exact component={Donate} />
      <Route path="/Cause" exact component={Cause} />
      <Route path="/gallery" exact component={Gallery} />
    </Switch>
  );

  return (
    <div className="App">
      <Suspense fallback={<p>Loading</p>}>{routes}</Suspense>
    </div>
  );
};

export default App;
